/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyFollowUpQuestionnaireOption,
  PharmacyFollowUpQuestionnaireOptionFromJSON,
  PharmacyFollowUpQuestionnaireOptionFromJSONTyped,
  PharmacyFollowUpQuestionnaireOptionToJSON,
} from "./";

export const PharmacyFollowUpQuestionnaireTypename = "PharmacyFollowUpQuestionnaire" as const;

/**
 *
 * @export
 * @interface PharmacyFollowUpQuestionnaire
 */
export interface PharmacyFollowUpQuestionnaire {
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  answerPattern?: PharmacyFollowUpQuestionnaireAnswerPatternEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  category?: PharmacyFollowUpQuestionnaireCategoryEnum;
  /**
   *
   * @type {number}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  id: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  isRequiredAnswer?: boolean;
  /**
   *
   * @type {Array<PharmacyFollowUpQuestionnaireOption>}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  options: Array<PharmacyFollowUpQuestionnaireOption>;
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  question: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnaire
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyFollowUpQuestionnaireAnswerPatternEnum {
  SingleSelection = "single_selection",
  MultipleSelection = "multiple_selection",
  FreeEntry = "free_entry",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyFollowUpQuestionnaireCategoryEnum {
  ConcomitantMedication = "concomitant_medication",
  MedicationEffect = "medication_effect",
  MedicationStatus = "medication_status",
  Consultation = "consultation",
  PatientInformation = "patient_information",
  LifeFunctioning = "life_functioning",
  LifeCharacteristic = "life_characteristic",
}

export function PharmacyFollowUpQuestionnaireFromJSON(json: any): PharmacyFollowUpQuestionnaire {
  return PharmacyFollowUpQuestionnaireFromJSONTyped(json, false);
}

export function PharmacyFollowUpQuestionnaireFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyFollowUpQuestionnaire {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyFollowUpQuestionnaireTypename,

    answerPattern: !exists(json, "answer_pattern") ? undefined : json["answer_pattern"],
    category: !exists(json, "category") ? undefined : json["category"],
    id: json["id"],
    isRequiredAnswer: !exists(json, "is_required_answer") ? undefined : json["is_required_answer"],
    options: (json["options"] as Array<any>).map(PharmacyFollowUpQuestionnaireOptionFromJSON),
    question: json["question"],
  };
}

export function PharmacyFollowUpQuestionnaireToJSON(object?: PharmacyFollowUpQuestionnaire | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answer_pattern: value.answerPattern,
    category: value.category,
    id: value.id,
    is_required_answer: value.isRequiredAnswer,
    options: (value.options as Array<any>).map(PharmacyFollowUpQuestionnaireOptionToJSON),
    question: value.question,
  };
}
